import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Member } from 'src/app/model/member.model';
import { Book } from 'src/app/model/book.model';
import { BookService } from './book.service';
import { DateService } from 'src/app/core/service/date.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { BehaviorSubject, catchError, map, of, Subject, Subscription, switchMap } from 'rxjs';
import Swal from 'sweetalert2';
import liff from '@line/liff';
import { SelectItem } from 'primeng/api';
import { SelectedItemService } from 'src/app/core/service/selected-item.service';
import { NgxSignaturePadComponent, NgxSignatureOptions } from '@eve-sama/ngx-signature-pad';
import { ScrollPanel } from 'primeng/scrollpanel';
import { ReservationSign } from 'src/app/model/resPeriodStatus.model';
@Component({
  selector: 'app-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss'],
})
export class BookComponent implements OnInit {
  @ViewChild('sig', { static: false }) pad!: NgxSignaturePadComponent;
      options: NgxSignatureOptions = {
        backgroundColor: '#fff',
        width: 500,
        height: 300
      };
  /** 同意書Scroll */
  @ViewChild('consentFormScrollPanel') public scrollPanel: ScrollPanel;
  /**===訂閱管理=== */
  subscribes: Subscription = new Subscription();
  private searchSubject = new Subject<any>();

  /**===狀態控制=== */
  Step = 1;
  isLoading = false;
  isOptionLoading = false;
  /** 是否已閱讀完同意書(滾動至最底) */
  public isConsentFormRead: boolean = false;
  isScrollBottom = false;
  isAgreed = false;
  isFinalLoading = false;
  /**有選門市才可開放選時段 */
  isSelectedStore = false; 
  isNew: boolean = false;
  /**判斷所選日期是否可預約 */
  isBookable = false;
  showErr = false;

  /**===資料模型=== */
  model: Book; //表單內容
  editModel: any = {}; //預覽表單
  /**同意書簽名model */
  drawData: ReservationSign;
  
  /**===門市預約相關=== */
  StoreList: any[] = [];
  StoreSelectList: SelectItem[] | null = null;
  PetList: any[] = [];
  PetSelectList: SelectItem[] | null = null;
  orinRoomTypeList: any[] = []; //房型列表(全部)
  RoomTypeList: any[] = []; //房型列表(篩選後)
  RoomTypeSelectList: SelectItem[] | null = null; //房型列表(篩選後)
  SpecialDateList: any[] = []; //特殊日方案
  AvailableRooms: any[] = []; //取得的空房
   /**每周休假日 */
  disabledDays: any[] = []; 
  /**特殊休假日 */
  disabledDates: any[] = []; 
  /**休假日設定 */
  storeSchedules: any[] = []; 
  /**特殊休假日 */
  storeUnSchedules: any[] = []; 
  
  /**===參數=== */
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  UserName: string;
  LoginUser: Member;
  selectStore: any = {}; //選取的門市
  resMinDate: Date;
  TotalPrice = 0;
  ErrMsg = '';
  /**匯款資訊 */
  RemitInfo = ''; 
  /**匯款$ */
  RemitMoney = ''; 
  /** 同意書內容 */
  public consentFormContent: string;
  nowTime: string = '';
  nowDate: string = '';
  
  constructor(
    private route: ActivatedRoute,
    private BookService: BookService,
    private DateService: DateService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private SelectedItemService: SelectedItemService
  ) {}

  ngOnInit(): void {
    // 取得querystring param
    var query = this.route.queryParams.pipe(
      switchMap(params => {
        this.CompanyID = params['CompanyID'];
        this.UserID = params['UserID'];
        this.Liff_ID = params['Liff_ID'];
        return this.subscription(); // 取得初始化資料
      })
    ).subscribe(isFinished => {
      if (isFinished) this.setDefaultValue();
    });

    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );
    this.initSearchSubscription();
    this.subscribes.add(query);
    this.subscribes.add(currentUser);
  }
  
  //#region  初始化
  /**初始化 */
  subscription() {
    this.isOptionLoading = true;
    return this.BookService.GetDefaultData(this.CompanyID, this.UserID).pipe(
      map(res => {
        this.isOptionLoading = false;
        if (res.ErrorFlag === '2') {
          this.handleError("您目前無法進行預約，請聯絡該門市。",true);
          return false;
        }
        this.getDataSucceed(res);
        return true;
      }),
      catchError(() => {
        this.isOptionLoading = false;
        return of(false);
      })
    );
  }
  /**初始化表單資料 */
  setDefaultValue() {
    this.model = new Book();
    this.model.ResDateS = this.DateService.GetToday();
    this.model.StoreNo = '';
    this.model.ResDateE = '';
    this.model.RoomType = '';
    this.model.PetNo = '';
    this.model.CompanyID = this.CompanyID;
  }
  /** 初始化搜尋訂閱 (關鍵優化) */
  initSearchSubscription() {
    const searchSub = this.searchSubject.pipe(
      switchMap(payload => {
        this.isLoading = true;
        return this.BookService.GetBooked(payload).pipe(
          catchError(err => {
            this.isLoading = false;
            return of(null);
          })
        );
      })
    ).subscribe(res => {
      if (res) {
        this.GetBookedSucceed(res);
      } else {
        this.isLoading = false;
      }
    });
    this.subscribes.add(searchSub);
  }
  //#endregion

  //#region 按鈕事件
  getDataSucceed(res: any) {
    this.nowDate = this.DateService.GetToday();
    this.nowTime = this.DateService.GetNowTime();
    if (!!res.ErrorFlag && res.ErrorFlag == '1') {
      this.handleError(res.ErrorMsg);
      return;
    }

    this.StoreList = res['Stores'];
    this.StoreSelectList = this.SelectedItemService.convertToSelectItem(
      res['Stores'],
      'StoreNo',
      'StoreName'
    );
    this.orinRoomTypeList = res['RoomTypes'];
    this.RoomTypeSelectList = this.SelectedItemService.convertToSelectItem(
      res['RoomTypes'],
      'RoomTypeNo',
      'RoomTypeName'
    );
    this.PetList = res['Pets'];
    this.PetSelectList = this.SelectedItemService.convertToSelectItem(
      res['Pets'],
      'PetNo',
      'PetName'
    );
    this.storeSchedules = res['Schedules'];
    this.storeUnSchedules = res['UnSchedules'];
    //如果是首次使用要填寫同意書
    this.isNew = res['isNew'];
    this.consentFormContent = "";
    if(this.isNew){
        this.Step = 0;
        this.drawData = new ReservationSign();
        this.drawData.CompanyID = this.CompanyID;
        this.drawData.UserID = this.UserID;
        this.isConsentFormRead = false;
        this.BookService.GetConsentForm(this.CompanyID).subscribe((result: any)=>{
          if (result?.ErrorFlag === '1'){
              this.handleError('錯誤資訊：' + result.ErrorMsg);
              return;
          }
          const currentDate = new Date().toLocaleDateString();
          this.consentFormContent = result.replace(/(日期)([:：]?\s*)(.*?)(\r?\n|$)/, `$1: ${currentDate}`);
          if (this.pad) {
            if (!this.scrollPanel?.contentViewChild) return;
              // 當有開啟簽名板時，檢查是否有閱讀完同意書，再開啟確認按鈕
              this.scrollPanel.contentViewChild.nativeElement.addEventListener('scroll', this.onCheckSignatureAndReadConsentForm.bind(this));
            }   
          });
    }
    this.isOptionLoading = false;
  }
  /**選擇房型 */
  SelectRoomType() {
    //重置價格
    this.TotalPrice = 0;  
    const result = this.AvailableRooms.filter(
      (s) => s.RoomTypeNo == this.model.RoomType
    );
    
    if (result.length == 0) {
      this.showErr = true;
      this.ErrMsg = '該房型已經客滿';
    } else {
      this.showErr = false;
      this.ErrMsg = '';
      //計算房價
      this.ToCalculate();
    }
  }
  /**下一步 */
  async nextStep(currentStep: number) {
    this.isLoading = true;
    switch (currentStep) {
      case 0:
        if(this.pad.isEmpty())
        {
          this.isLoading = false;
          return this.handleError('請先簽名');
        }
        if(!this.isAgreed)
        {
          this.isLoading = false;
          return this.handleError('請勾選同意條款');
        }

        this.drawData.SignPath = this.pad.toDataURL();

        this.BookService.SaveSign(this.drawData).subscribe(res=>{
            this.isLoading = false;
            if(res.ErrorFlag !== '1')
              this.Step++;
          });
        break;
      case 1:
        this.prepareEditModel();
        this.isLoading = false;
        this.Step++;
        break;
      case 2:
        this.submitBooking();
        break;
      case 3: 
        this.clearAll();
        this.Step = 1;
        this.isLoading = false;
        break;
      default:
        break;
    }
  }
  private prepareEditModel(){
    const store = this.StoreList.find(
                  (s) => s.StoreNo == this.model.StoreNo);
    const Pet = this.PetList.find(s=> s.PetNo == this.model.PetNo); 
    const room = this.RoomTypeList.find(
                  (s) => s.RoomTypeNo == this.model.RoomType
                );
    this.editModel = {
          ...this.model,
          CompanyID: this.CompanyID,
          LineID: this.UserID,
          StoreName: store?.StoreName,
          PetName: Pet ? `${Pet.PetName}(${Pet.VarietyName})` : '',
          RoomTypeName: room?.RoomTypeName,
          ResDateS: this.formatToDateString(this.model.ResDateS),
          ResDateE: this.formatToDateString(this.model.ResDateE),
          Price: this.TotalPrice
    };
  }
  /**提交預約 */
  submitBooking() {
    this.isFinalLoading = true;

    // 確保傳送給後端的日期格式正確
    const finalPayload = {
      ...this.editModel,
      ResDateS: this.formatToDateString(this.editModel.ResDateS),
      ResDateE: this.formatToDateString(this.editModel.ResDateE),
    };

    this.BookService.CreateBook(finalPayload).subscribe({
      next: (result) => {
        this.isFinalLoading = false;
        
        if (result.ErrorFlag === '1') {
          this.handleError(result.ErrorMsg);
          this.isLoading = false;
          return;
        }

        // 預約成功處理
        this.UserName = result['MemberName'] ?? '';
        const remit = result['Param'] ?? ''; 
        if (!!remit) {
          let remits = remit.split(';');
          this.RemitMoney = remits[0] ?? '';
          this.RemitInfo = (remits.length > 1) ? remits[1] : "";
        }

        // 嘗試發送 LINE 訊息
        this.sendLineNotification().then(() => {
          // 跳轉到 Step 3 (完成畫面)
          this.Step = 3; 
          this.isLoading = false;
        }).catch((err: any) => {
          // 即使 LINE 失敗，預約已成功，仍跳至完成頁，但提示訊息
          console.error('LINE Notify Error:', err);
          this.Step = 3;
          this.isLoading = false;
        });
      },
      error: (err) => {
        this.isFinalLoading = false;
        this.isLoading = false;
        this.handleError('網路連線異常，請稍後再試');
      }
    });
  }
  /** 封裝 LINE 訊息發送邏輯 */
  private async sendLineNotification(): Promise<void> {
    try {
      await liff.init({ liffId: this.Liff_ID, withLoginOnExternalBrowser: true });

      if (!liff.isInClient()) {
        this.handleError('請從 LINE 聊天中開啟此頁面才能發送訊息');
        return;
      }

      const content = [
        '預約成功！以下為您的資訊：',
        `門市：${this.editModel.StoreName}`,
        `入住：${this.editModel.ResDateS}`,
        `退房：${this.editModel.ResDateE}`,
        `房型：${this.editModel.RoomTypeName}`,
        `寵物：${this.editModel.PetName}`,
        `總計：$${this.TotalPrice}`,
        this.RemitMoney ? `匯款金額：${this.RemitMoney}` : '',
        this.RemitInfo ? `匯款資訊：${this.RemitInfo}` : '',
      ].filter(line => !!line).join('\n');

      await liff.sendMessages([{ type: 'text', text: content }]);
    } catch (err) {
      throw err;
    }
  }
  
  /**上一步 */ 
  prevStep() {
    this.Step--;
  }
  //#endregion

  //#region 資料處理
  /**
   * 取得房型
   * remark: 變更時間、門市時，要重新取得房型&空房(時間可能會參考門市營業時間，但目前不加入此功能)
   */
  GetBookedAndResetRoomType() {
    this.ClearSearchResult();
    if (!this.model.StoreNo) {
      this.isSelectedStore = false;
      this.isLoading = false;
      return;
    }

    this.isSelectedStore = true;
    this.selectStore = this.StoreList.find((s) => s.StoreNo == this.model.StoreNo);

    //過濾房型
    this.RoomTypeList = this.orinRoomTypeList.filter(
        (s) => s.StoreNo === this.model.StoreNo
    );
    this.RoomTypeSelectList = this.SelectedItemService.convertToSelectItem(
        this.RoomTypeList,
        'RoomTypeNo',
        'RoomTypeName'
    );

    //更新休假日
    this.setDisabledDate();
    // 重要：取得最小可選日期，並將其賦值給組件控制變數
    const minDateStr: string = this.getResMinDate();
    // 設定給 p-calendar [minDate] 使用的 Date 物件
    this.resMinDate = new Date(minDateStr);
    // 檢查目前選中的日期。若 model.ResDateS 為 Date 物件或字串，都先轉成 Date 比對
    const currentSelectedDate = new Date(this.model.ResDateS);
    
    if (this.isDateDisabled(currentSelectedDate)) {
        this.model.ResDateS = minDateStr;
    }
      
    // 格式化目前選擇的日期 (確保同步)
    this.model.ResDateS = this.formatToDateString(this.model.ResDateS);
    this.model.ResDateE = this.formatToDateString(this.model.ResDateE);
    // 只有在門市與日期都齊全時才執行搜尋
    if (this.model.StoreNo && this.model.ResDateS && this.model.ResDateE) {
      this.SearchBook();
    }
  }
  /** 共用的檢查邏輯 */
  isDateDisabled(date: Date): boolean {
    if (!date) return false;
    const day = date.getDay();
    const dateStr = this.formatToDateString(date);

    // 檢查固定週休
    const isWeeklyOff = this.disabledDays.some(d => d === day);
    // 檢查特殊休假
    const isSpecialOff = this.disabledDates.some(d => this.formatToDateString(d) === dateStr);

    return isWeeklyOff || isSpecialOff;
  }
  /**設定休假日 */ 
  setDisabledDate() {
    if (!this.selectStore || !this.selectStore.StoreNo) return;
    // 1. 取得每週固定休假 (0-6)
    const schedule = this.storeSchedules.filter(x => x.StoreNo == this.selectStore.StoreNo);
    this.disabledDays = schedule.map(x => x.DateSerial === 7 ? 0 : x.DateSerial);

    // 2. 取得特殊休假日
    const unSchedule = this.storeUnSchedules.filter(x => x.StoreNo == this.selectStore.StoreNo);
    const dateArr: Date[] = [];

    unSchedule.forEach(period => {
      let curr = new Date(period.DateS);
      let end = new Date(period.DateE);
      // 設定為凌晨，避免比對時因為幾點幾分導致失效
      curr.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      while (curr <= end) {
        dateArr.push(new Date(curr));
        curr.setDate(curr.getDate() + 1);
      }
    });
    
    this.disabledDates = dateArr;
  }
  /** 取得目前可預約日期 */
  getResMinDate(): string {
    var that = this;
    /**檢查是否為休假日 */
    function isDateDisabled(date: Date) {
      return (
        that.disabledDays.some((x) => x == date.getDay()) ||
        that.disabledDates.some((x) => that.DateService.DateToString(x, 'yyyy-mm-dd') === that.DateService.DateToString(date, 'yyyy-mm-dd'))
      );
    }
    /**設定可預約時段 */
    function getDefaultResDate() {
      var thisDate = new Date(that.nowDate);
      
      while (isDateDisabled(thisDate)) {
        thisDate.setDate(thisDate.getDate() + 1);
      }

      return that.DateService.DateToString(thisDate, 'yyyy-mm-dd');
    }

    var defaultResDate = getDefaultResDate();
    // 如果現在時間已過營業結束時間，則最小日期再加一天
    if (this.nowTime >= this.selectStore.OpenTimeTo) {
      const nextDay = new Date(defaultResDate);
      nextDay.setDate(nextDay.getDate() + 1);
      
      // 加完一天後仍要檢查是否為休假日
      while (isDateDisabled(nextDay)) {
        nextDay.setDate(nextDay.getDate() + 1);
      }
      defaultResDate = this.DateService.DateToString(nextDay, 'yyyy-mm-dd');
    }

    return defaultResDate;
  }
  /** 判斷所選日期區間是否可預訂 */
  isDateRangeBookable(): boolean {
    var that = this;
    if (!this.model.ResDateS || !this.model.ResDateE) {
      return false; // 日期未選齊，視為不可送出
    }

    let start = new Date(this.model.ResDateS);
    let end = new Date(this.model.ResDateE);
    /**檢查是否為休假日 */
    function isDateDisabled(date: Date) {
      return (
        that.disabledDays.some((x) => x == date.getDay()) ||
        that.disabledDates.some((x) => that.DateService.DateToString(x, 'yyyy-mm-dd') === that.DateService.DateToString(date, 'yyyy-mm-dd'))
      );
    }
    // 防呆：結束日 < 起始日
    if (start > end) {
      return false;
    }

    let checkDate = new Date(start);

    while (checkDate <= end) {
      if (isDateDisabled(checkDate)) {
        return false; // 只要遇到一天休假 → 不可預訂
      }
      checkDate.setDate(checkDate.getDate() + 1);
    }

    return true;
  }
  /**內容重置 */
  ClearSearchResult() {
    //畫面內容重置
    this.model.RoomType = '';
    this.AvailableRooms = [];
    this.SpecialDateList = [];
    this.showErr = false;
    this.ErrMsg = '';
    //輸出結果重置
    this.editModel.ResDateS = '';
    this.editModel.ResDateE = '';
    this.editModel.StoreName = '';
    this.editModel.RoomTypeName = '';
    this.editModel.PetName = '';
  }
  /**查詢住房資料 */
  SearchBook() {
    this.isLoading = true;
    // 如果沒有門市編號，不發動請求
    if (!this.model.StoreNo) {
      this.isLoading = false;
      return;
    }
    const getBooked = this.BookService.GetBooked(this.model).subscribe(
      (res) => {
        this.GetBookedSucceed(res);
      }
    );
    this.subscribes.add(getBooked);
    this.searchSubject.next(this.model);
  }
  GetBookedSucceed(res: any) {
    // 1. 錯誤處理
    if (res.ErrorFlag === '1') {
      this.handleError(res.ErrorMsg);
      this.isLoading = false;
      return;
    }

    // 2. 正常資料處理
    this.AvailableRooms = res.rooms || [];
    this.SpecialDateList = res.spDate || [];

    // 如果這時候 model 已經有選房型了，要重新驗證一次該房型是否還在空房內
    if (this.model.RoomType) {
      this.SelectRoomType();
    }

    // 同步到 editModel 供預覽頁使用
    this.editModel = { ...this.editModel, ...this.model };
    
    this.isLoading = false;
  }
  
  /**重整表單 */
  clearAll() {
    this.editModel = {};
    this.setDefaultValue();
    this.TotalPrice = 0;
    
    this.AvailableRooms = [];
    this.showErr = false;
    this.isLoading = false;
    this.ErrMsg = '';
  }
  
  /**計算價格 */
  ToCalculate() {
    if (!this.model.ResDateS || !this.model.ResDateE || !this.model.RoomType) {
      this.TotalPrice = 0;
      return;
    }
    const startStr = this.formatToDateString(this.model.ResDateS);
    const endStr = this.formatToDateString(this.model.ResDateE);
    // 檢查日期合法性
    if (startStr > endStr) {
      this.model.ResDateE = '';
      this.handleError('入住日期不得晚於退房日期');
      return;
    }
    //準備房價陣列
    const room = this.orinRoomTypeList.find(s=> 
      s.StoreNo == this.model.StoreNo && s.RoomTypeNo === this.model.RoomType
    );
    if (!room) {
      this.TotalPrice = 0;
      return;
    }
    const prices = [room.SunPrice, room.MonPrice, room.TuePrice
      , room.WedPrice, room.ThuPrice, room.FriPrice, room.StaPrice];

    // 遍歷日期計算 (支援特殊日)
    let tempTotal = 0;
    let curr = new Date(startStr);
    const end = new Date(endStr);

    if (startStr === endStr) {
      const dayOfWeek = curr.getDay();
      const spPlan = this.SpecialDateList.find(sp => sp.SpDateM.DateFrom <= startStr && sp.SpDateM.DateTo >= startStr);
      
      if (spPlan) {
        const spPriceObj = spPlan.SpDateDs.find((d: any) => d.RoomTypeNo === this.model.RoomType);
        const spWeekPrices = [
          spPriceObj.SunPrice, spPriceObj.MonPrice, spPriceObj.TuePrice, 
          spPriceObj.WedPrice, spPriceObj.ThuPrice, spPriceObj.FriPrice, spPriceObj.StaPrice
        ];
        tempTotal = spWeekPrices[dayOfWeek];
      } else {
        tempTotal = prices[dayOfWeek];
      }
    }else{
      while (curr < end) { // 退房日當天不計費，所以用 <
        const currStr = this.formatToDateString(curr);
        const dayOfWeek = curr.getDay();

        // 檢查特殊日
        const spPlan = this.SpecialDateList.find(sp => sp.SpDateM.DateFrom <= currStr && sp.SpDateM.DateTo >= currStr);
        
        if (spPlan) {
          const spPriceObj = spPlan.SpDateDs.find((d: any) => d.RoomTypeNo === this.model.RoomType);
          const spWeekPrices = [spPriceObj.SunPrice, spPriceObj.MonPrice, spPriceObj.TuePrice, spPriceObj.WedPrice, spPriceObj.ThuPrice, spPriceObj.FriPrice, spPriceObj.StaPrice];
          tempTotal += spWeekPrices[dayOfWeek];
        } else {
          tempTotal += prices[dayOfWeek];
        }
        
        curr.setDate(curr.getDate() + 1);
      }
    }

    this.TotalPrice = tempTotal;
  }
  //#endregion

  //#region 驗證
  /** 檢查第一步是否填寫完整且合法 */
  isStep1Ready(): boolean {
    // 1. 基礎必填檢查：確保所有欄位都有值
    const isBasicFilled = 
      !!this.model.StoreNo && 
      !!this.model.ResDateS && 
      !!this.model.ResDateE && 
      !!this.model.RoomType && 
      !!this.model.PetNo;

    // 2. 業務邏輯檢查：
    // - 必須有空房 (AvailableRooms)
    // - 必須通過日期區間檢查 (不含休假)
    // - 目前沒有 API 回傳的錯誤訊息 (showErr)
    const isLogicValid = 
      this.AvailableRooms.length > 0 && 
      this.isDateRangeBookable() && 
      !this.showErr;

    return isBasicFilled && isLogicValid;
  }
  isFirstStepFinish() {
    return (
      this.editModel.ResDateS &&
      this.editModel.ResDateE &&
      this.editModel.StoreName &&
      this.editModel.RoomTypeName &&
      this.editModel.PetName
    );
  }
  /**判斷是否客滿 */
  isFullBooked() {
    return !!this.AvailableRooms && this.AvailableRooms.length > 0;
  }
  /**檢查是否開放房型選擇 */
  isRoomOpen(){  
    // 只有在選了門市與正確日期區間後，才允許選擇房型
    return !!this.model.StoreNo && !!this.model.ResDateS 
          && !!this.model.ResDateE && this.isDateRangeBookable();
  }
  CheckSign(){
    return this.isScrollBottom && !this.pad.isEmpty();
  }
  //#endregion

  //#region  簽名板
  ngAfterViewInit() {
    if (!this.scrollPanel?.contentViewChild) return; // 避免 undefined

    this.scrollPanel.contentViewChild.nativeElement.addEventListener(
      'scroll',
      this.onCheckSignatureAndReadConsentForm.bind(this)
    );
  }
  /** 檢查是否簽名並且閱讀同意書 */
  private onCheckSignatureAndReadConsentForm(event: Event) {
    if (!this.scrollPanel?.contentViewChild) return;
      const scrollElement = this.scrollPanel.contentViewChild.nativeElement;
      // 計算是否滾動到底部
      const isScrollToBottom = scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight <= 1; // 誤差值 1
      this.isConsentFormRead = isScrollToBottom;
      if(this.isConsentFormRead)
        this.isScrollBottom = true;
  }
  /**清除簽名 */
  clear() {
      this.pad.clear();
      this.isAgreed = false;
  }
  onBegin() { /* 開始簽名事件 */ }
  onEnd() { /* 結束簽名事件 */ }
  //#endregion

  //#region   其他功能
  private formatToDateString(date: any): string {
    if (!date) return '';
    // 如果已經是字串且格式正確，直接回傳即可，避免重複 new Date 造成的時區偏移
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    return this.DateService.DateToString(new Date(date), 'yyyy-mm-dd');
  }
  /**
     * 處理錯誤彈窗
     * @param msg 錯誤訊息內容
     * @param isFatal 是否為嚴重錯誤（如果是，關閉彈窗後導回首頁）
     */
  private handleError(msg: string, isFatal: boolean = false): void {
      Swal.fire({
        icon: 'error',
        title: '抱歉，發生錯誤',
        text: msg,
        confirmButtonText: '確定',
        confirmButtonColor: '#d33', // 習慣上錯誤用紅色
        allowOutsideClick: !isFatal // 嚴重錯誤不允許點擊外面關閉
      }).then((result) => {
        if (isFatal && result.isConfirmed) {
          // 導回首頁，並帶上必要的參數以免 LIFF 失效
          this.router.navigate(['/'], { 
            queryParams: { 
              CompanyID: this.CompanyID, 
              UserID: this.UserID, 
              Liff_ID: this.Liff_ID 
            } 
          });
        }
      });
  }
  //#endregion

  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
